import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';
import useService from '../../utils/useService';
import { dehydrateFormData } from '../../utils/formDataParser';
import { TSegmentFormData } from '../../utils/types';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { uploadCsvCreate } = useService();

	const createSegment = async (createdData: any) => {
		try {
			const { csvData } = createdData;
			const formData = new FormData();
			setShowLoader(true);

			_forEach(_keys(csvData), (key: string) => {
				formData.append(key, csvData[key]);
			});
			uploadCsvCreate(formData).then(
				(res: any) => {
					if (res?.status !== 200 || !res?.data?.success) {
						showAlert(res?.data?.error || 'Error occured while creating segment', { type: 'error' });
						setShowLoader(false);
						history.goBack();
					} else {
						showAlert('Segment CSV uploaded');
						setShowLoader(false);
						history.goBack();
					}
				},
				(err: any) => {
					showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
					setShowLoader(false);
				}
			);
		} catch (error: any) {
			showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: TSegmentFormData) => {
		createSegment(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
